// extracted by mini-css-extract-plugin
export default {"userName":"List_userName__p61eG","secondary":"List_secondary__KHeYG"};